import React from "react";
import ProdutoServicoTipoObjetoService from "../../services/ProdutoServicoTipoObjetoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaProdutoServicoTipoObjeto extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: ProdutoServicoTipoObjetoService,
            labels: {
                title: 'Lista de Tipo de Objeto(s)',
                btnNewRegister: 'Tipo de Objeto',
            },
            keyItem: 'idProdutoServicoTipoObjeto',
            urlForm: '/CadProdutoServicoTipoObjeto',
            itensFilter: ["idProdutoServicoTipoObjeto", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idProdutoServicoTipoObjeto}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}